/* eslint-disable import/no-anonymous-default-export */
import libraryRepository from '../repositories/libraryRepository'
import { useAppSelector } from '../store/hooks'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

function useGetProficiency() {
	const {
		auth: { user },
		matriculate: { classSelect },
	} = useAppSelector((state) => state)
	const navigate = useNavigate()

	const findOnboarding = user?.onboarding_all?.find(
		(onboading) => onboading.curso_id === classSelect?.curso_id
	)

	useEffect(() => {
		if (!classSelect?.curso_id) {
			if (user?.modo_curso_unico) {
				navigate('/curso')
			} else {
				navigate('/')
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [classSelect])

	const courseId = Number(classSelect?.curso_id || findOnboarding?.curso_id)

	const { data, isLoading, isSuccess } =
		libraryRepository.useGetProficiencyQuery(
			{ cursoId: courseId },
			{ skip: !courseId }
		)

	return { data, isLoading, isSuccess }
}

function useGetProgress() {
	const {
		auth: { user },
		matriculate: { classSelect },
	} = useAppSelector((state) => state)
	const navigate = useNavigate()

	const findOnboarding = user?.onboarding_all?.find(
		(onboading) => onboading.curso_id === classSelect?.curso_id
	)

	useEffect(() => {
		if (!classSelect?.curso_id) {
			if (user?.modo_curso_unico) {
				navigate('/curso')
			} else {
				navigate('/')
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [classSelect])

	const courseId = Number(classSelect?.curso_id || findOnboarding?.curso_id)

	const { data, isLoading, isSuccess } = libraryRepository.useGetProgressQuery(
		{ userId: user?.id || 0, cursoId: courseId },
		{ skip: !user?.id }
	)

	return { data, isLoading, isSuccess }
}

function useGetUnitsMutation() {
	const [_getUnits, { data, isLoading, isSuccess, isError }] =
		libraryRepository.useGetUnitsMutation()

	async function execute({
		courseId,
		moduleId,
	}: {
		courseId: number
		moduleId: number
	}) {
		try {
			await _getUnits({ courseId, moduleId })
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess, isError }
}

function useGetUnitsRecordedMutation() {
	const [_getUnits, { data, isLoading, isSuccess, isError }] =
		libraryRepository.useGetUnitsRecordedMutation()

	async function execute({ courseId }: { courseId: number }) {
		try {
			await _getUnits({ courseId })
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess, isError }
}

function useGetLessonMutation() {
	const [_getLesson, { data, isLoading, isSuccess, isError }] =
		libraryRepository.useGetLessonMutation()

	async function execute({ topicId }: { topicId: number }) {
		try {
			await _getLesson({ topicId })
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess, isError }
}

function useCompleteTopicMutation() {
	const {
		matriculate: { classSelect },
		auth: { user },
	} = useAppSelector((state) => state)

	const [_getCompleteLesson, { data, isLoading, isSuccess, isError }] =
		libraryRepository.useCompleteLessonMutation()

	async function execute({ topicoId }: { topicoId: number }) {
		try {
			const findOnboarding = user?.onboarding_all?.find(
				(onboading) => onboading.curso_id === classSelect?.curso_id
			)

			if (!user?.id) return

			if (
				!findOnboarding?.curso_id &&
				classSelect?.['type-course']?.toUpperCase() === 'AO VIVO'
			)
				return

			if (
				!classSelect?.curso_id &&
				classSelect?.['type-course']?.toUpperCase() === 'GRAVADO'
			)
				return

			await _getCompleteLesson({
				cursoId: findOnboarding?.curso_id || classSelect?.curso_id || 0,
				usuarioId: user?.id,
				topicoId,
			})
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess, isError }
}

export default {
	getProficiency: useGetProficiency,
	getUnitsRecordedMutation: useGetUnitsRecordedMutation,
	getUnitsMutation: useGetUnitsMutation,
	getLessonMutation: useGetLessonMutation,
	getProgress: useGetProgress,
	completeTopic: useCompleteTopicMutation,
}
